<template>
    <div class= "font-nunito flex h-screen">
        <div class="flex flex-row h-full w-full">
            <Nav class="w-16 laptop:w-250  border-r border-gray-300" />
            <div class="flex flex-col h-full bg-white w-full pt-5 tablet:px-5">
                <router-view class="flex-grow" />
                <Footer class="pr-5 pb-3" />
            </div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/layout/Navigation.vue';
import Footer from '@/components/layout/Footer.vue';

export default {
    name: 'blankLayout',
    props: {
        msg: String
    },
    components: {
        Footer,
        Nav
    }
};
</script>

<style scoped lang="scss">
</style>
